module.exports = __webpack_public_path__ + "static/media/serviceDashboard.80a665b3.svg";